import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@app/auth-client";
import { PortalProvider } from "@app/portal-sdk";
import App from "./App";
import { ShellProvider } from "./components/ShellContext";
import "../../../styles/global.css";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <PortalProvider apiBaseUrl={apiBaseUrl}>
          <ShellProvider>
            <App />
          </ShellProvider>
        </PortalProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
